import { Card, CardContent, CardHeader } from '@material-ui/core';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { Finding, SEVERITY_ORDER } from '../utils/types';
import { countBySeverity, getSeverityColor } from '../utils/severity';
import { EmptyChart } from './EmptyChart';

interface SeverityChartProps {
  findings: Finding[];
}

export const SeverityChart = ({ findings }: SeverityChartProps) => {
  const counts = countBySeverity(findings);
  const data = SEVERITY_ORDER.map(sev => ({
    name: sev,
    value: counts[sev],
  })).filter(d => d.value > 0);

  if (data.length === 0) {
    return <EmptyChart title="Distribuição por Severidade" />;
  }

  return (
    <Card>
      <CardHeader title="Distribuição por Severidade" />
      <CardContent>
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              innerRadius={50}
              outerRadius={90}
              paddingAngle={2}
            >
              {data.map(entry => (
                <Cell
                  key={entry.name}
                  fill={getSeverityColor(entry.name as any)}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
